<template>
    <div class="carousel-cell">
      <div class="material-card material-item">
          <div class="material-card__inner-wrapper">
              <div v-if="isMaterialOpenedInIframe" :class="material.id" class="material-card__thumb-wrapper material-card-link" :style="bgStyle">
                  <img :src="material.image" alt="" :class="material.id" class="material-card__thumb material-card-link">
              </div>
              <a v-else :href="selectUrl" :class="material.id" target="_blank" class="material-card__thumb-wrapper material-card-link" :style="bgStyle">
                  <img :src="material.image" alt="" :class="material.id" class="material-card__thumb material-card-link">
              </a>
              <span v-if="isMaterialOpenedInIframe" :class="material.id" class="material-card__title font-bold material-card-link">{{ material.title }}</span>
              <a v-else :href="selectUrl" :class="material.id" target="_blank" class="material-card__title font-bold material-card-link">{{ material.title }}</a>
              <p class="material-card__description">{{ material.description }}</p>
              <template v-if="material.subInfoHeading && material.subInfo">
                <hr class="material-card__line">
                <span class="material-card__login-label">{{ material.subInfoHeading }}</span>
                <p class="material-card__description">{{ material.subInfo }}</p>
              </template>
          </div>
          <div class="material-card__bottom-inner-wrapper">
              <button v-if="isMaterialOpenedInIframe" type="button" @click="handleOpenIframe" :class="[material.id]" class="material-card__enter-button material-card-link" >
                 <img
                  :class="material.id"
                  class="material-card__enter-icon"
                  src="@/assets/images/materials-enter.svg"
                  alt="enter"
                  />
                  Wejdź
              </button>
              <a v-else :href="selectUrl" target="_blank" :class="[material.id]" class="material-card__enter-button material-card-link">
                  <img
                  :class="material.id"
                  class="material-card__enter-icon"
                  src="@/assets/images/materials-enter.svg"
                  alt="enter"
                  />
                  Wejdź
              </a>
              <div class="material-card__bottom-info material-card-bottom-info">
                  <template v-if="material.bottomInfo">
                    <button class="material-card__info-icon">
                        <img src="@/assets/images/icons/i_white.svg" />
                    </button>
                    <span class="material-card__info">{{ material.bottomInfo }}</span>
                  </template>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  isAndroid, isIOS, isMacOs, isWindows,
} from 'mobile-device-detect';

export default {
  name: 'MaterialCard',
  data() {
    return {
      isAndroid,
      isIOS,
      iframeSrc: null,
    };
  },
  props: {
    material: Object,
  },
  computed: {
    ...mapGetters('auth', ['isOfficeLogin']),
    selectUrl() {
      let url = '';
      const { androidUrl: androidLink, iosUrl: iosLink, webUrl: linkUrl } = this.material;
      if ((isAndroid && androidLink) || (isWindows && androidLink)) {
        url = androidLink;
      } else if ((isIOS && iosLink) || (isMacOs && iosLink)) {
        url = iosLink;
      } else if (linkUrl) {
        url = linkUrl;
      } else if (androidLink) {
        url = androidLink;
      } else {
        url = iosLink;
      }
      return url;
    },
    isMaterialOpenedInIframe() {
      return !!this.iframeSrc;
    },
    bgStyle() {
      return {
        'background-color': this.material.background,
      };
    },
  },
  created() {
    const materialsToOpenInIframe = [
      'activity-park',
      'bear-band-red',
      'bear-band-red',
      'bear-band-yellow',
      'bear-band-blue',
      'fun-park',
      'master-powers-corner',
      'projekt',
    ];
    if (materialsToOpenInIframe.includes(this.material.name)) {
      this.iframeSrc = this.material.webUrl;
    }
  },
  methods: {
    handleOpenIframe() {
      this.$root.$emit('open-material', {
        iframeSrc: this.iframeSrc,
        materialId: this.material.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-cell {
  padding-left: 35px;
  padding-right: 35px;
  @apply px-4;
  width: 335px;
  min-height: 100%;
  display: flex;
  @media screen and (max-width: 1632px) {
    @apply w-1/3;
  }
  @media screen and (max-width: 1500px) {
    @apply px-3 w-1/3;
  }
  @media screen and (max-width: 1425px) {
    @apply px-3 w-1/2;
  }
  @media screen and (max-width: 1380px) {
    @apply w-1/2;
  }
  @media screen and (max-width: 991px) {
    @apply w-full;
    padding-left: 0;
    padding-right: 0;
    display: contents;
  }
}
.material-card{
    width: 100%;
    border-radius: 24px;
    background-color: #fff;
    display: flex;
    justify-content: stretch;
    align-items: flex-start;
    flex-wrap: wrap;
    &:last-child{
        margin-right: 0;
    }
    &--inactive{
      pointer-events: none;
    }
    &__inner-wrapper{
        padding: 29px 29px 0 29px;
        align-self: flex-start;
        flex-basis: 100%;
    }
    &__thumb-wrapper{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 4px;
        height: 150px;
    }
    &__thumb{
        max-width: 100%;
        max-height: 90%;
        display: block;
    }
    &__title{
        font-size: 22px;
        line-height: 25px;
        text-decoration: none;
        margin-bottom: 1px;
        display: block;
        @media screen and (max-width: 1447px) {
          min-height: 50px;
        }
    }
    &__description-wrapper{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      @media screen and (max-width: 1602px) {
        flex-direction: column;
        align-items: flex-start;
      }
      @media screen and (max-width: 1425px) {
        flex-direction: row;
        align-items: center;
      }
      @media screen and (max-width: 1166px) {
        flex-direction: column;
        align-items: flex-start;
      }
      @media screen and (max-width: 991px) {
        flex-direction: row;
        align-items: center;
      }
      @media screen and (max-width: 641px) {
        flex-direction: column;
        align-items: flex-start;
      }
    }
    &__description{
        font-size: 16px;
        line-height: 18px;
    }
    &__copy-text{
      font-weight: bold;
    }
    &__copyclipboard {
      @apply relative flex items-center ml-3;
      font-size: 16px;
      line-height: 18px;
      background: transparent;
      color: #EC268F;
      @media screen and (max-width: 1602px) {
        @apply ml-0 mt-2;
      }
      @media screen and (max-width: 1425px) {
        @apply ml-3 mt-0;
      }
      @media screen and (max-width: 1166px) {
        @apply ml-0 mt-2;
      }
      @media screen and (max-width: 991px) {
        @apply ml-3 mt-0;
      }
      @media screen and (max-width: 641px) {
        @apply ml-0 mt-2;
      }
      &.active {
        color: rgb(23.921569%,64.313728%,28.235295%);
      }
      img {
        margin-right: 4px;
        width: 20px;
        height: 17.5px;
      }
      .tooltip {
        @apply hidden absolute text-white bg-black;
        opacity: 0;
        top: -8px;
        left: 50%;
        transform: translate(-50%, -80%);
        width: auto;
        white-space: nowrap;
        padding: 10px 20px;
        border-radius: 4px;
        pointer-events: none;
        font-size: 12px;
        line-height: 14px;
        transition: 0.5s transform, 0.3s opacity;
        @media screen and (min-width: 768px) {
          @apply block;
        }
        &:after,
        &:before {
          content: "";
        }
        &:before {
          @apply absolute;
          top: 100%;
          left: 50%;
          height: 0;
          width: 0;
          border: solid transparent;
          pointer-events: none;
          border-color: rgba(0, 0, 0, 0);
          border-top-color: #1b181a;
          border-width: 4px;
          margin-left: -4px;
          opacity: 0.9;
        }
      }
      &:hover .tooltip,
      &:focus .tooltip {
        opacity: 0.9;
        transform: translate(-50%, -100%);
        pointer-events: auto;
      }
    }
    &__line{
        width: 100%;
        background-color: #D1D1D1;
        height: 1px;
        padding: 0;
        margin: 15px 0;
    }
    &__login-label{
        font-size: 16px;
        font-weight: bold;
        display: block;
        margin-bottom: 3px;
    }
    &__enter-icon{
        width: 14px;
    }
    &__enter-button{
        margin: 20px 29px 28px 29px;
        padding: 10px 20px;
        background-color: #EC268F;
        color: #fff;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        border-radius: 20px;
        display: inline-block;
        text-decoration: none;
        &--inactive{
            background-color: #D1D1D1;
            cursor: not-allowed;
        }
    }
    &__bottom-inner-wrapper{
        flex-basis: 100%;
        align-self: flex-end;
    }
    &__bottom-info{
        padding: 13px 28px 17px 27px;
        border-radius: 0 0 24px 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-height: 70px;
    }
    &__info-icon{
        width: 12px;
        min-width: 12px;
        color: #fff;
        margin-right: 9px;
    }
    &__info{
        color: #fff;
        font-size: 11px;
        line-height: 13px;
    }
}
</style>
